import React, { useEffect } from "react";
import DOMPurify from "dompurify";

const LinkView = ({ html = "" }) => {
  useEffect(() => {
    const hook = (node) => {
      if (node.tagName !== "A") return;

      let href = (node.getAttribute("href") || "").trim();
      if (!href) return;

      const lower = href.toLowerCase();

      if (/^\s*(javascript|data):/i.test(lower)) {
        node.removeAttribute("href");
        node.setAttribute("rel", "noopener noreferrer");
        return;
      }

      if (href.startsWith("//")) {
        href = window.location.protocol + href;
      } else if (
        !/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(href) &&
        !href.startsWith("/") &&
        !href.startsWith("#") &&
        !href.startsWith("?")
      ) {
        if (/^[^\s]+\.[^\s]+$/.test(href)) {
          href = "https://" + href;
        }
      }

      try {
        const url = new URL(href, window.location.href);
        node.setAttribute("href", url.toString());
        if (url.origin !== window.location.origin) {
          node.setAttribute("target", "_blank");
          node.setAttribute("rel", "noopener noreferrer");
        }
      } catch (e) {
        node.removeAttribute("href");
        node.setAttribute("rel", "noopener noreferrer");
      }
    };

    DOMPurify.addHook("afterSanitizeAttributes", hook);
    return () => DOMPurify.removeHook("afterSanitizeAttributes", hook);
  }, []);

  const clean = DOMPurify.sanitize(html, {
    ALLOWED_ATTR: ["href", "title", "target", "rel"],
  });

  return <div dangerouslySetInnerHTML={{ __html: clean }} />;
};

export default LinkView;
